export const KILOMETER_MIN = 17;
export const KILOMETER_MAX = 80;

export const MILE_MIN = 10;
export const MILE_MAX = 50;

export const CUSTOM_LOCATION_RADIUS_MIN = 1;
